import { render } from "./SartActivity.vue?vue&type=template&id=2406ea76&scoped=true"
import script from "./SartActivity.vue?vue&type=script&lang=js"
export * from "./SartActivity.vue?vue&type=script&lang=js"

import "./SartActivity.vue?vue&type=style&index=0&id=2406ea76&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2406ea76"]])

export default __exports__